import React from 'react';
export function TopBar() {
  return <div className="bg-blue-700 text-white text-center text-[11px] md:text-sm py-1.5 md:py-2 px-3 md:px-4 leading-tight" data-id="element-260">
      ⏰ Precio de lanzamiento por tiempo limitado — Después sube $10.000 ARS y
      no vuelve a bajar
    </div>;
}